import React, {
  useEffect,
  useState,
  useContext,
  useRef,
  useCallback,
} from "react";
import Showimage from "./modalshowimage";
import ShowLPR from './modallprlist'
import { getgate, getlprlist, eventlist,getlprmonthly,getlprdaily,getlprdetail } from "../../services/lpr";
import ReportCreate from "../chart/reportCreator";
import moment from "moment";
import DatePicker from "react-datepicker";
import BranchContext from "../context/branch";
import FontAwesome from "react-fontawesome";
import Header from "./headerlist";
import PrivilegeContext from "../context/privilege";

const Lprlist = (props) => {
  const { menuItems } = useContext(PrivilegeContext);
  const [refresh, setrefresh] = useState(new Date());
  const { currentBranch } = useContext(BranchContext);
  const [search, setsearch] = useState("");
  const [name, setname] = useState("");
  const [lastupdate, setlastupdate] = useState(new Date());
  const [groupid, setgroupid] = useState(3);
  const [siteid, setsiteid] = useState(0);
  const [typeid, settypeid] = useState(0);
  const [id, setid] = useState(0);
  const [edit, setedit] = useState({ id: 0, list: {}, header: "เพิ่มรายการ" });
  const [lprmlist, setlprmlist] = useState([]);
  const [data1, setData1] = useState({});
  const [data2, setData2] = useState({});
  const [data3, setData3] = useState({});
  const [hour, sethour] = useState("");
  const [hasMore, setHasMore] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [pageSize, setPageSize] = useState(15);
  const [total, setTotal] = useState(0);
  const [devicelist, setsdevicelist] = useState([]);
  const [hourlist, sethourlist] = useState([]);
  const [startdate, setstartdate] = useState(new Date());
  const [isOpenLprlist, setisOpenLprlist] = useState(false);

  const [lprdetaillist, setlprdetaillist] = useState([]);
  const [imageUrl, setImageUrl] = useState("");

  const [truckgrouplist, settruckgrouplist] = useState([]);
  const [sizelist, setsizelist] = useState([]);
  const [readerlist, setreaderlist] = useState([]);
  const [controllerlist, setcontrollerlist] = useState([]);
  const [loadcelllist, setloadcelllist] = useState([]);
  const [indicatorlist, setindicatorlist] = useState([]);
  const [branchlist, setbranchlist] = useState([]);

  const [isOpen, setisOpen] = useState(false);
  // const [isOpenImage, setisOpenImage] = useState(false);
  // const [isOpenDevice, setisOpenDevice] = useState(false);
  const [data, setdata] = useState([]);
  const [messageerror, setmessageerror] = useState("");
  const [header, setheader] = useState("");
  const [showonscroll, setshowonscroll] = useState(false);
  const [showprogress, setshowprogress] = useState(false);
  const [completed, setcompleted] = useState(50);
  const [selectlist, setselectlist] = useState([]);
  const [value, setValue] = useState(0);
  const [Authors, setAuthors] = useState(false);
  const [imagetypelist, setimagetypelist] = useState([]);
  const [list, setlist] = useState([]);
  // const [editlist, seteditlist] = useState([]);
  // useEffect(() => {
  //   if (!currentBranch) return;

  //   const loadData = async () => {
  //     const { data: result } = await getAuthors("device");
  //     if (result.status === "success") {
  //       setAuthors(true);
  //     }
  //   };
  //   loadData();
  // }, [currentBranch]);

  // useEffect(() => {
  //   if (!currentBranch) return;
  //   if (id === 0) return;

  //   const loadRegister = async () => {
  //     const { data: result } = await getImagelist(id);

  //     if (result.status === "success") {
  //       setlist(result.data.list);
  //     }
  //   };

  //   loadRegister();
  // }, [currentBranch, id, refresh]);

  // useEffect(() => {
  //   if (!currentBranch) return;

  //   if (!pageSize) return;

  //   setsdevicelist([]);
  // }, [currentBranch, pageSize, search, value, lastupdate]);

  useEffect(() => {
    if (!currentBranch) return;
    const loadData = async () => {
      const { data: result } = await getgate();
      if (result.status === "success") {
        setselectlist(result.data.list);
        setLoading(false);
      }
    };
    loadData();
  }, [currentBranch]);



  useEffect(() => {
    if (!currentBranch) return;
    if (!value) return;
    if (value ===0) return;
      const loadData = async () => {
        const { data: result } = await getlprmonthly(
          value
        );
        if (result) {
          setlprmlist(result);
        }
      };
      loadData();  
  }, [currentBranch, value]);



  useEffect(() => {
    if (!currentBranch) return;
    if (!startdate) return;
    if (!hour) return;
    if (!value) return;
      const loadData = async () => {
        const { data: result } = await getlprdetail(moment(startdate, "YYYY-MM-DD").format("YYYY-MM-DD"),typeid,value,hour);
        if (result) {
          setlprdetaillist(result);        
        }
      };
      loadData();
    
  }, [currentBranch, startdate,hour,value,typeid]);



  useEffect(() => {
    if (!currentBranch) return;
    if (!value) return;
    if (value ===0) return;
    const loadData = async () => {
      const { data: result } = await getlprdaily(
        value,
        moment(startdate, "YYYY-MM-DD").format("YYYY-MM-DD")
      );
      if (result) {
        sethourlist(result);
      }
    };
    loadData();
  }, [currentBranch, value, startdate]);

  useEffect(() => {
    if (!lprmlist || !currentBranch) return;
    const chart = () => {
      let label = [];
      let totolin = [];
      let totolout = [];
    
      for (const dataObj of lprmlist) {
        label.push(dataObj.ddate);
        totolin.push(parseInt(dataObj.totalin));
        totolout.push(parseInt(dataObj.totalout));     
      }
      const data = {
        series: [
          { name: "เข้า", data: totolin },
          { name: "ออก", data: totolout },
        ],
        dataLabels: {
          formatter: function (val, opts) {
            return opts.w.config.series[opts.seriesIndex];
          },
        },
        yLabels: label,
        headers: "ข้อมูลเข้าออกแยกตามวัน",
        type: "bar",
        stacked: true,
      };
      // const data2 = {
      //   series: [totalright,totaledit,totoladdnew],
      //   yLabels: ["เข้า", "ออก"],
      //   headers: "เปรียบเทียบ ไม่ Scan / Scan )",
      //   type: "pie",
      //   stacked: true,
      // };
      // setchartdatacomparetotal(data2);

      setData1(data);
    };
    chart();
  }, [lprmlist, currentBranch]);

  useEffect(() => {
    if (!hourlist || !currentBranch) return;
    const chart = () => {
      let label = [];
      let totalin = [];
      let totalout = [];
      for (const dataObj of hourlist) {
        label.push(dataObj.hour);
        totalin.push(parseInt(dataObj.totalin));
        totalout.push(parseInt(dataObj.totalout));
      }
      const data = {
        series: [{ name: "เข้า", data: totalin },{ name: "ออก", data: totalout } ],
        dataLabels: {
          formatter: function (val, opts) {
            return opts.w.config.series[opts.seriesIndex];
          },
        },
        yLabels: label,
        headers: "ข้อมูลเข้าออก แยกตามชั่วโมง",
        type: "bar",
        stacked: true,
      };
      setData2(data);
    };
    chart();
  }, [hourlist, currentBranch]);


  // useEffect(() => {
  //   if (!currentBranch) return;
  //   const loadData = async () => {
  //     const { data: result } = await truckscalegroupselected();
  //     if (result.status === "success") {
  //       settruckgrouplist(
  //         result.data.list.map((item) => {
  //           return {
  //             value: item._id,
  //             label: item.name,
  //           };
  //         }
  //         ))
  //     }
  //   };
  //   loadData();
  // }, [currentBranch]);

  // useEffect(() => {
  //   if (!currentBranch) return;
  //   const loadData = async () => {
  //     const { data: result } = await sizeselected();
  //     if (result.status === "success") {
  //       setsizelist(
  //         result.data.list.map((item) => {
  //           return {
  //             value: item._id,
  //             label: item.name,
  //           };
  //         }
  //         ))
  //     }
  //   };
  //   loadData();
  // }, [currentBranch]);

  // useEffect(() => {
  //   if (!currentBranch) return;
  //   const loadData = async () => {
  //     const { data: result } = await loadcellselected();
  //     if (result.status === "success") {
  //       setloadcelllist(
  //         result.data.list.map((item) => {
  //           return {
  //             value: item._id,
  //             label: item.name,
  //           };
  //         }
  //         ))
  //     }
  //   };
  //   loadData();
  // }, [currentBranch]);

  // useEffect(() => {
  //   if (!currentBranch) return;
  //   const loadData = async () => {
  //     const { data: result } = await indicatorselected();
  //     if (result.status === "success") {
  //       setindicatorlist(
  //         result.data.list.map((item) => {
  //           return {
  //             value: item._id,
  //             label: item.name,
  //           };
  //         }
  //         ))
  //     }
  //   };
  //   loadData();
  // }, [currentBranch]);

  // useEffect(() => {
  //   if (!currentBranch) return;
  //   const loadData = async () => {
  //     const { data: result } = await controllerselected();
  //     if (result.status === "success") {
  //       setcontrollerlist(
  //         result.data.list.map((item) => {
  //           return {
  //             value: item._id,
  //             label: item.name,
  //           };
  //         }
  //         ))
  //     }
  //   };
  //   loadData();
  // }, [currentBranch]);

  // useEffect(() => {
  //   if (!currentBranch) return;
  //   const loadData = async () => {
  //     const { data: result } = await readerselected();
  //     if (result.status === "success") {
  //       setreaderlist(
  //         result.data.list.map((item) => {
  //           return {
  //             value: item._id,
  //             label: item.name,
  //           };
  //         }
  //         ))
  //     }
  //   };
  //   loadData();
  // }, [currentBranch]);
  // useEffect(() => {
  //   if (!currentBranch) return;
  //   const loadData = async () => {
  //     const { data: result } = await brancselected();
  //     if (result.status === "success") {
  //       setbranchlist(
  //         result.data.list.map((item) => {
  //           return {
  //             value: item._id,
  //             label: item.name,
  //           };
  //         }
  //       ))
  //     }
  //   };
  //   loadData();
  // }, [currentBranch]);

  // useEffect(() => {
  //   if (!currentBranch) return;
  //   if (!menuItems) return;
  //   if (menuItems.length === 0) return;
  //   if (!pageSize || !pageNumber) return;
  //   setLoading(true);
  //   setError(false);
  //   setshowprogress(true);
  //   const loadData = async () => {
  //     const { data: result } = await eventlist(
  //       value,
  //       search,
  //       pageSize,
  //       pageNumber
  //     );
  //     if (result.status === "success") {
  //       setTotal(result.data.total);
  //       setshowprogress(false);
  //       setsdevicelist((prevData) => {
  //         return [...new Set([...prevData, ...result.data.list])];
  //       });
  //       setHasMore(result.data.list.length > pageSize - 1);
  //       setLoading(false);
  //     } else if (
  //       result.status === "error" &&
  //       result.message === "invalid token"
  //     ) {
  //       const urlGoBack = "logout";
  //       setTimeout(props.history.replace(urlGoBack), 1000);
  //     }
  //   };
  //   loadData();
  // }, [
  //   currentBranch,
  //   search,
  //   value,
  //   pageSize,
  //   pageNumber,
  //   lastupdate,
  //   menuItems,
  // ]);

  // useEffect(() => {
  //   if (!currentBranch) return;
  //   if (id === 0) return;

  //   const loadRegister = async () => {
  //     const { data: result } = await getImageType();

  //     if (result.status === "success") {
  //       setimagetypelist(result.data.list);
  //     }
  //   };

  //   loadRegister();
  // }, [currentBranch, id]);

  const observer = useRef();
  const lastBookElementRef = useCallback(
    (node) => {
      if (node && node.offsetTop > 0) {
        setshowonscroll(true);
      }
      // console.log('node = ' ,node);
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        //  console.log(entries[0].isIntersecting,hasMore);

        if (entries[0].isIntersecting && hasMore) {
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  const handlegroupChange = (event) => {
    setgroupid(event);

    setsearch(name);
    setPageNumber(1);
  };

  const handleChangeSelect = ({ name, item, classname }) => {
    const clear = [...selectlist];
    const index1 = clear.findIndex((x) => x.classname === "btn btn-primary");
    if (index1 > -1) {
      clear[index1].classname = "btn btn-outline-dark";
      setselectlist(clear);
    }
    const subobject = {
      _id: item,
      name: name,
      classname: "btn btn-primary",
    };
    const sub = [...selectlist];
    const index = sub.findIndex((x) => x._id === item);
    sub[index] = subobject;
    setselectlist(sub);
    setValue(item);
    setPageNumber(1);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      setPageNumber(1);
      setsearch(name);
    }
  };
  const handlesiteChange = (event) => {
    setsiteid(event.currentTarget.value);
    setsearch(name);
    setPageNumber(1);
  };

  const handleChange = (event) => {
    setsiteid(event);
    setPageNumber(1);
    setsearch(name);

    //    console.log('Click event',pageNumber);
  };

  const handleChangStartDate = (value) => {
    setstartdate(value);
  };

  const handleTextchange = (event) => {
    setname(event.currentTarget.value);
  };
  const handleSearchClick = () => {
    setPageNumber(1);
    setsearch(name);
  };
  const handleCancleSubmit = () => {
    setisOpen(false);
  };
  const handleConfirmSubmit = () => {
    setlastupdate(new Date());
    setisOpen(false);
    // console.log('confirm')
  };
  const scrollToTop = () => {
    setPageNumber(1);
    setshowonscroll(false);
  };

  const handleonClick = () => {};
  const handleonHourClick = (hour,index) => {
    sethour(hour);
    settypeid(index)
    setisOpenLprlist(true);
  };
  const onClose = () => {
    setisOpenLprlist(false)
    }
const handleImageClick = (event) => {
  setImageUrl(event);
  setisOpen(true);
}
const handelClose = () => {
  setisOpen(false);
};
  return (
    <>
    <ShowLPR
     isOpen={isOpenLprlist} handleClick ={handleImageClick} onCancel={onClose} list={lprdetaillist} 
    />
    <Showimage
     isOpen={isOpen} onCancel={handelClose} list={imageUrl} 
    />

      <div className="container">
        <div className="row">
          <div className="col-auto">
            <i>
              ประตู <span className="label label-default"></span>
            </i>
            <div className="mt-1">
              <Header
                list={selectlist}
                onChange={handleChangeSelect}
                disabled={loading}
              />
            </div>
          </div>

          {/* <div className="col-lg-4  col-sm-6 m-2  ">
            <div className="form-group">
              <Input
                name="devicename"
                value={name}
                placeholder="ระบุชื่อ เพื่อค้นหา"
                onChange={handleTextchange}
                onClick={handleSearchClick}
                onKeyPress={handleKeyPress}
                search="ค้นหา"
              />
            </div>
          </div> */}
        </div>
      </div>
      <div className="row">
        <div className="col-auto">
          {/* <div className="container">
            <button
              className="btn btn-primary"
              onClick={() => handleAdd(0, "new")}
            >
              <FontAwesome name="plus" />
              <i /> เพิ่มใหม่
            </button>
            <br />
            <br />
          </div> */}
        </div>
        {/* <div className="col-auto">
          <p className="text-success">
            แสดงข้อมูล {devicelist ? devicelist.length : 0} / {total} รายการ
          </p>
        </div> */}
      </div>

      <div className="row">
        {/* <div className="col-lg-6">
          <div className="d-flex justify-content-center">
            <span
              className="badge rounded-pill bg-warning"
              style={{ fontSize: "16px" }}
            >
              ข้อมูลการทำงาน {" "}
            </span>
          </div>
        </div> */}
        <div className="col-lg-6">
          <div className="d-flex justify-content-center">
            <div className="col-auto ">
              <i>
                วันที่ <span className="label label-default"></span>
              </i>

              <div className="mt-1" style={{ marginTop: 20, marginBottom: 10 }}>
                <DatePicker
                  todayButton="Today"
                  dateFormat="dd/MM/yyyy"
                  selected={startdate}
                  onChange={handleChangStartDate}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      { value===0 ? null : <div className="row">
        <div className="col-12">
          <div className="mt-1">
            {data2.series !== undefined && (
              <ReportCreate
                data={data2}
                type={"bar"}
                labelposition="top"
                palette={"palette6"}
                onclick={handleonHourClick}
              />
            )}
          </div>
        </div>

        <div className="col-12">
          <div className="mt-1">
            {data1.series !== undefined && (
              <ReportCreate
                data={data1}
                type={"bar"}
                labelposition="top"
                palette={"palette6"}
                onclick={handleonClick}
              />
            )}
          </div>
        </div>
      </div>}

      {/* {<ScrollToTop onClick={scrollToTop} />} */}

      {/* <Renderdevice
        list={devicelist}
        handleOnClick={handleOnClick}
        error={error}
        handleOnEdit={handleAdd}
        lastBookElementRef={lastBookElementRef}
      /> */}
    </>
  );
};

export default Lprlist;
